function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M505.492 106.113C503.809 100.777 499.457 96.7266 494.016 95.4023C488.598 94.0781 482.859 95.6797 478.91 99.625L411.328 167.188L359.594 152.383L344.789 100.652L412.375 33.0664C416.34 29.1211 417.922 23.3828 416.598 17.9609C415.273 12.5234 411.223 8.19141 405.887 6.48438C392.234 2.19922 377.707 0 362.668 0C280.32 0 213.332 66.9883 213.332 149.332C213.332 166.762 216.258 183.594 222.039 199.508L18.7734 402.773C6.65625 414.871 0 430.934 0 448C0 465.066 6.65625 481.129 18.7734 493.227C30.8711 505.344 46.9336 512 64 512C81.0664 512 97.1289 505.344 109.227 493.227L312.492 289.961C328.406 295.742 345.238 298.668 362.668 298.668C445.012 298.668 512 231.68 512 149.332C512 134.293 509.801 119.766 505.492 106.113V106.113Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512,
  fill: "white"
})));

var SvgWrench = function SvgWrench(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrench, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrench.306d0495.svg";
export { ForwardRef as ReactComponent };